import { useEvent } from "@dnd-kit/utilities";
import { useSetRecoilState } from "recoil";

import { errors, ITranslatableItem, TError } from "@ryde/shared";

import { landingMessagesAtom } from "../atoms";
import { LandingStepEnum, LandingStepErrorsEnum } from "../enums";
import { createActiveStepError, createMessage } from "../helpers";
import { useLandingActions } from "./use-landings-actions";

interface IHandleErrors {
  error: TError | undefined;
  defaultAction?: (e: TError | undefined) => void;
}

interface IUseLandingOtpErrors {
  handleErrors: (params: IHandleErrors) => void;
}

export const useLandingOtpErrors = (): IUseLandingOtpErrors => {
  const { goToStep, setActiveStepErrors } = useLandingActions();
  const setServerErrors = useSetRecoilState(landingMessagesAtom);

  const handleErrors = useEvent(
    ({ error, defaultAction }: IHandleErrors): void => {
      switch ((error as ITranslatableItem)?.translationKey) {
        case errors.landing.passengerNoFound:
          setServerErrors(createMessage([errors.landing.passengerNoFound]));
          goToStep(LandingStepEnum.LoginStep);
          break;
        case errors.landing.passengerIsNotEligible:
          setActiveStepErrors(
            createActiveStepError(LandingStepErrorsEnum.PassengerIsNotEligible),
          );
          goToStep(LandingStepEnum.ErrorStep);
          break;
        case errors.landing.passengerIsProbablyBlocked:
          setActiveStepErrors(
            createActiveStepError(
              LandingStepErrorsEnum.PassengerIsProbablyBlocked,
            ),
          );
          goToStep(LandingStepEnum.ErrorStep);
          break;
        case errors.landing.passengerAlreadyRegistered:
          setActiveStepErrors(
            createActiveStepError(
              LandingStepErrorsEnum.PassengerAlreadyRegistered,
            ),
          );
          goToStep(LandingStepEnum.ErrorStep);
          break;

        default:
          defaultAction?.(error);
          break;
      }
    },
  );

  return { handleErrors };
};
